import {
  batchLoadingDataSourcePlugin,
  columnChooserPlugin,
  columnFiltersPlugin,
  columnsPlugin,
  dynamicHeightPlugin,
  exportPlugin,
  localStoragePlugin,
  searchPlugin,
  serverDataSourcePlugin,
} from "../plugins";

/**
 * @param {Object} options
 * @param {String} options.columnOverrides
 * @param {String} [options.dataSourceURL]
 * @param {String} [options.dataSourceMode]
 * @param {Boolean} [options.exportEnabled = true]
 * @param {String} options.storageKey
 *
 * @returns {import("../datagrid").Pack}
 */
export function databasePack(options) {
  return ($container) => {
    const dataSourceURL = options.dataSourceURL ?? $container.getAttribute("data-source-url");
    const dataSourceMode = options.dataSourceMode ?? $container.getAttribute("data-source-mode");

    const dataSourcePlugin =
      dataSourceMode == "batch_loading" ? batchLoadingDataSourcePlugin(dataSourceURL) : serverDataSourcePlugin(dataSourceURL);

    const maybeExportPlugin = options.exportEnabled !== false ? exportPlugin() : [];

    return [
      columnChooserPlugin({ resetColumnsKey: options.storageKey }),
      columnFiltersPlugin(),
      columnsPlugin({ columnOverrides: options.columnOverrides }),
      databaseStylePlugin(),
      dataSourcePlugin,
      dynamicHeightPlugin(),
      maybeExportPlugin,
      localStoragePlugin(options.storageKey),
      searchPlugin(),
    ];
  };
}

function databaseStylePlugin() {
  return {
    options: {
      allowColumnReordering: true,
      columnAutoWidth: true,
      showColumnLines: false,
      rowAlternationEnabled: false,
    },
  };
}
